import { render } from "./FormEditarAtividade.vue?vue&type=template&id=5ded42e5&scoped=true"
import script from "./FormEditarAtividade.vue?vue&type=script&lang=js"
export * from "./FormEditarAtividade.vue?vue&type=script&lang=js"

import "./FormEditarAtividade.vue?vue&type=style&index=0&id=5ded42e5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ded42e5"]])

export default __exports__